import React, { useRef, useEffect, useState, useCallback } from "react";
import { Parallax, ParallaxLayer } from "@react-spring/parallax";
import "./Home.css";

/* ================= MOBILE HOOK ================= */
function useIsMobile() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  return isMobile;
}

// ADD THIS COMPONENT ABOVE:
// export default function Home()

function RootsShowcase() {

  const [frame, setFrame] = useState(0);

  // ✅ NEW: progressive image loading
  const [loadedCount, setLoadedCount] = useState(1);

  const isMobile = window.innerWidth <= 768;
  const isMobile390 = window.innerWidth <= 390;
  const isMobile430 = window.innerWidth <= 430;

  const leftImages = [
    {
      src: "https://res.cloudinary.com/dsfhaqrhn/image/upload/v1779087227/root_to_plant_1_g68efv.jpg",

      width: isMobile390
        ? "250px"
        : isMobile430
          ? "260px"
          : isMobile
            ? "220px"
            : "400px",

      height: isMobile390
        ? "250px"
        : isMobile430
          ? "250px"
          : isMobile
            ? "320px"
            : "420px",

      top: isMobile390
        ? "40px"
        : isMobile430
          ? "70px"
          : isMobile
            ? "80px"
            : "90px",

      left: isMobile390
        ? "45px"
        : isMobile430
          ? "75px"
          : isMobile
            ? "100px"
            : "100px",
    },
    {
      src: "https://res.cloudinary.com/dsfhaqrhn/image/upload/v1779087228/root_to_plant_2_toqnvz.jpg",
      width: isMobile390
        ? "170px"
        : isMobile430
          ? "260px"
          : isMobile
            ? "220px"
            : "280px",

      height: isMobile390
        ? "250px"
        : isMobile430
          ? "250px"
          : isMobile
            ? "320px"
            : "420px",

      top: isMobile390
        ? "40px"
        : isMobile430
          ? "70px"
          : isMobile
            ? "80px"
            : "80px",

      left: isMobile390
        ? "85px"
        : isMobile430
          ? "75px"
          : isMobile
            ? "100px"
            : "160px",
    },
    {
      src: "https://res.cloudinary.com/dsfhaqrhn/image/upload/v1779087228/root_to_plant_3_z8omdv.jpg",
      width: isMobile390
        ? "190px"
        : isMobile430
          ? "260px"
          : isMobile
            ? "220px"
            : "400px",

      height: isMobile390
        ? "200px"
        : isMobile430
          ? "250px"
          : isMobile
            ? "320px"
            : "420px",

      top: isMobile390
        ? "50px"
        : isMobile430
          ? "40px"
          : isMobile
            ? "80px"
            : "30px",

      left: isMobile390
        ? "80px"
        : isMobile430
          ? "81px"
          : isMobile
            ? "100px"
            : "110px",
    },
    {
      src: "https://res.cloudinary.com/dsfhaqrhn/image/upload/v1779087228/root_to_plant_4_lvayng.jpg",
      width: isMobile390
        ? "200px"
        : isMobile430
          ? "260px"
          : isMobile
            ? "220px"
            : "400px",

      height: isMobile390
        ? "200px"
        : isMobile430
          ? "250px"
          : isMobile
            ? "320px"
            : "420px",

      top: isMobile390
        ? "50px"
        : isMobile430
          ? "40px"
          : isMobile
            ? "80px"
            : "30px",

      left: isMobile390
        ? "65px"
        : isMobile430
          ? "65px"
          : isMobile
            ? "100px"
            : "90px",
    },
    {
      src: "https://res.cloudinary.com/dsfhaqrhn/image/upload/v1779087229/root_to_plant_5_wyravn.jpg",
      width: isMobile390
        ? "190px"
        : isMobile430
          ? "260px"
          : isMobile
            ? "220px"
            : "400px",

      height: isMobile390
        ? "200px"
        : isMobile430
          ? "250px"
          : isMobile
            ? "320px"
            : "420px",

      top: isMobile390
        ? "40px"
        : isMobile430
          ? "30px"
          : isMobile
            ? "80px"
            : "30px",

      left: isMobile390
        ? "75px"
        : isMobile430
          ? "68px"
          : isMobile
            ? "100px"
            : "100px",
    },
    {
      src: "https://res.cloudinary.com/dsfhaqrhn/image/upload/v1779087230/root_to_plant_6_rsdzgj.jpg",
      width: isMobile390
        ? "200px"
        : isMobile430
          ? "260px"
          : isMobile
            ? "220px"
            : "400px",

      height: isMobile390
        ? "200px"
        : isMobile430
          ? "250px"
          : isMobile
            ? "320px"
            : "420px",

      top: isMobile390
        ? "40px"
        : isMobile430
          ? "30px"
          : isMobile
            ? "80px"
            : "30px",

      left: isMobile390
        ? "70px"
        : isMobile430
          ? "68px"
          : isMobile
            ? "100px"
            : "100px",
    },
    {
      src: "https://res.cloudinary.com/dsfhaqrhn/image/upload/v1779087230/root_to_plant_7_za7mir.jpg",
      width: isMobile390
        ? "220px"
        : isMobile430
          ? "260px"
          : isMobile
            ? "220px"
            : "450px",

      height: isMobile390
        ? "210px"
        : isMobile430
          ? "250px"
          : isMobile
            ? "320px"
            : "420px",

      top: isMobile390
        ? "20px"
        : isMobile430
          ? "30px"
          : isMobile
            ? "80px"
            : "10px",

      left: isMobile390
        ? "60px"
        : isMobile430
          ? "65px"
          : isMobile
            ? "100px"
            : "70px",
    },
  ];

  const rightImages = [
    {
      src: "https://res.cloudinary.com/dsfhaqrhn/image/upload/v1778501285/phonics_z4yqcs.jpg",

      objectPosition: "50% 30%",

      width: isMobile390
        ? "300px"
        : isMobile430
          ? "330px"
          : isMobile
            ? "220px"
            : "520px",

      height: isMobile390
        ? "230px"
        : isMobile430
          ? "270px"
          : isMobile
            ? "320px"
            : "420px",

      top: isMobile390
        ? "0px"
        : isMobile430
          ? "0px"
          : isMobile
            ? "60px"
            : "10px",

      left: isMobile390
        ? "30px"
        : isMobile430
          ? "40px"
          : isMobile
            ? "90px"
            : "10px",
    },
    {
      src: "https://res.cloudinary.com/dsfhaqrhn/image/upload/v1778496708/hindi_and_telugu_tutions_tiao1t.jpg",

      objectPosition: "50% 30%",
      width: isMobile390
        ? "300px"
        : isMobile430
          ? "330px"
          : isMobile
            ? "220px"
            : "520px",

      height: isMobile390
        ? "230px"
        : isMobile430
          ? "270px"
          : isMobile
            ? "320px"
            : "420px",

      top: isMobile390
        ? "0px"
        : isMobile430
          ? "0px"
          : isMobile
            ? "60px"
            : "10px",

      left: isMobile390
        ? "30px"
        : isMobile430
          ? "40px"
          : isMobile
            ? "90px"
            : "10px",
    },
    {
      src: "https://res.cloudinary.com/dsfhaqrhn/image/upload/v1779087615/vemana_and_sumathi_q7dcgg.jpg",

      objectPosition: "50% 30%",
      width: isMobile390
        ? "300px"
        : isMobile430
          ? "330px"
          : isMobile
            ? "220px"
            : "520px",

      height: isMobile390
        ? "230px"
        : isMobile430
          ? "270px"
          : isMobile
            ? "320px"
            : "420px",

      top: isMobile390
        ? "0px"
        : isMobile430
          ? "0px"
          : isMobile
            ? "60px"
            : "10px",

      left: isMobile390
        ? "30px"
        : isMobile430
          ? "40px"
          : isMobile
            ? "90px"
            : "10px",
    },
    {
      src: "https://res.cloudinary.com/dsfhaqrhn/image/upload/v1779087229/personallity_development_tqsfxt.jpg",

      objectPosition: "50% 30%",
      width: isMobile390
        ? "300px"
        : isMobile430
          ? "330px"
          : isMobile
            ? "220px"
            : "520px",

      height: isMobile390
        ? "230px"
        : isMobile430
          ? "270px"
          : isMobile
            ? "320px"
            : "420px",

      top: isMobile390
        ? "0px"
        : isMobile430
          ? "0px"
          : isMobile
            ? "60px"
            : "10px",

      left: isMobile390
        ? "30px"
        : isMobile430
          ? "40px"
          : isMobile
            ? "90px"
            : "10px",
    },
    {
      src: "https://res.cloudinary.com/dsfhaqrhn/image/upload/v1778484299/Bhagavat_gita_jbyoj8.jpg",

      objectPosition: "50% 30%",
      width: isMobile390
        ? "300px"
        : isMobile430
          ? "330px"
          : isMobile
            ? "220px"
            : "520px",

      height: isMobile390
        ? "230px"
        : isMobile430
          ? "270px"
          : isMobile
            ? "320px"
            : "420px",

      top: isMobile390
        ? "0px"
        : isMobile430
          ? "0px"
          : isMobile
            ? "60px"
            : "10px",

      left: isMobile390
        ? "30px"
        : isMobile430
          ? "40px"
          : isMobile
            ? "90px"
            : "10px",
    },
    {
      src: "https://res.cloudinary.com/dsfhaqrhn/image/upload/v1778500328/abacus_picture_vuqnhd.jpg",

      objectPosition: "50% 30%",
      width: isMobile390
        ? "300px"
        : isMobile430
          ? "330px"
          : isMobile
            ? "220px"
            : "520px",

      height: isMobile390
        ? "230px"
        : isMobile430
          ? "270px"
          : isMobile
            ? "320px"
            : "420px",

      top: isMobile390
        ? "0px"
        : isMobile430
          ? "0px"
          : isMobile
            ? "60px"
            : "10px",

      left: isMobile390
        ? "30px"
        : isMobile430
          ? "40px"
          : isMobile
            ? "90px"
            : "10px",
    },
    {
      src: "https://res.cloudinary.com/dsfhaqrhn/image/upload/v1778500348/competitive_exams_focus_pplpvj.jpg",

      objectPosition: "50% 30%",
      width: isMobile390
        ? "300px"
        : isMobile430
          ? "330px"
          : isMobile
            ? "220px"
            : "520px",

      height: isMobile390
        ? "230px"
        : isMobile430
          ? "270px"
          : isMobile
            ? "320px"
            : "420px",

      top: isMobile390
        ? "0px"
        : isMobile430
          ? "0px"
          : isMobile
            ? "60px"
            : "10px",

      left: isMobile390
        ? "30px"
        : isMobile430
          ? "40px"
          : isMobile
            ? "90px"
            : "10px",
    }
  ];


  // ✅ NEW: progressively load images
  useEffect(() => {
    const interval = setInterval(() => {
      setLoadedCount((prev) => {
        if (prev >= leftImages.length) {
          clearInterval(interval);
          return prev;
        }

        return prev + 1;
      });
    }, 400);

    return () => clearInterval(interval);
  }, [leftImages.length]);

  const nextFrame = () => {
    if (frame >= leftImages.length - 1) return;

    setFrame((prev) => prev + 1);
  };

  const prevFrame = () => {
    if (frame <= 0) return;

    setFrame((prev) => prev - 1);
  };

  // ✅ CHANGED: render only progressively loaded images
  const renderImages = (images) => {
    return images
      .slice(0, loadedCount)
      .map((image, index) => {
        const opacity = index === frame ? 1 : 0;

        return (
          <img
            key={index}
            src={image.src}
            alt=""
            className="panel"
            loading={index <= 1 ? "eager" : "lazy"}
            decoding="async"
            fetchpriority={index === 0 ? "high" : "low"}
            style={{
              opacity,
              zIndex: index,

              width: image.width,
              height: image.height,

              position: "absolute",

              top: image.top,
              left: image.left,
            }}
          />
        );
      });
  };

  return (
    <div className="home-scroll-container">

      <div className="sticky-wrapper">

        {/* LEFT IMAGE */}
        <div
          className="section-wrapper"
          style={{
            order: isMobile ? 2 : 2,
          }}
        >

          <div className="sticky-section">
            {renderImages(leftImages)}
          </div>

        </div>

        {/* RIGHT IMAGE */}
        <div
          className="section-wrapper"
          style={{
            order: isMobile ? 1 : 1,
          }}
        >

          <div className="sticky-section">
            {renderImages(rightImages)}
          </div>

        </div>

        {/* ARROWS */}
        <div className="button-wrapper">

          {/* LEFT BUTTON */}
          <div className="arrow-side">
            {frame > 0 && (
              <button
                className="arrow-btn"
                onClick={prevFrame}
              >
                ←
              </button>
            )}
          </div>

          {/* RIGHT BUTTON */}
          <div className="arrow-side right-align">
            {frame < leftImages.length - 1 && (
              <button
                className="arrow-btn"
                onClick={nextFrame}
              >
                →
              </button>
            )}
          </div>

        </div>

      </div>

    </div>
  );
}

function SchoolImageSlider({
  isMobile,
  imageMarginTop_initial_image,
  opacity,
}) {
  const [index, setIndex] = React.useState(0);
  const [isTransitioning, setIsTransitioning] = React.useState(true);

  const [isFirstCycle, setIsFirstCycle] = React.useState(true);

  const indexRef = React.useRef(0);
  const autoRef = React.useRef(null);
  const idleRef = React.useRef(null);

  const images = [
    "https://res.cloudinary.com/dsfhaqrhn/image/upload/v1779778595/school_buillding_full_kofsi3.png",
    "https://res.cloudinary.com/dsfhaqrhn/image/upload/v1779778740/Children_playing_3_w7hheu.jpg",
    "https://res.cloudinary.com/dsfhaqrhn/image/upload/v1779778742/Children_playing_1_tf5att.jpg",
    "https://res.cloudinary.com/dsfhaqrhn/image/upload/v1779778742/Children_playing_2_esy3mf.jpg",
  ];

  const sliderWidth =
    window.innerWidth <= 360
      ? "88vw"
      : window.innerWidth <= 375
        ? "86vw"
        : window.innerWidth <= 390
          ? "84vw"
          : window.innerWidth <= 414
            ? "82vw"
            : window.innerWidth <= 430
              ? "80vw"
              : window.innerWidth <= 480
                ? "76vw"
                : window.innerWidth <= 768
                  ? "68vw"
                  : "39vw";

  const sliderHeight =
    window.innerWidth <= 360
      ? "300px"
      : window.innerWidth <= 375
        ? "320px"
        : window.innerWidth <= 390
          ? "340px"
          : window.innerWidth <= 414
            ? "360px"
            : window.innerWidth <= 430
              ? "380px"
              : window.innerWidth <= 480
                ? "420px"
                : window.innerWidth <= 768
                  ? "460px"
                  : "560px";

  const slides = [...images, images[0]];
  const total = images.length;

  /* keep ref in sync */
  React.useEffect(() => {
    indexRef.current = index;
  }, [index]);

  /* ================= AUTO ENGINE ================= */
  const startAuto = useCallback(() => {
    if (autoRef.current) clearTimeout(autoRef.current);

    const delay =
      isFirstCycle && indexRef.current === 0 ? 1000 : 4000;

    autoRef.current = setTimeout(() => {
      setIndex((prev) => {
        const next = prev + 1;
        return next;
      });

      if (isFirstCycle) setIsFirstCycle(false);
    }, delay);
  }, [isFirstCycle]);

  /* run auto whenever index changes */
  React.useEffect(() => {
    startAuto();
    return () => clearTimeout(autoRef.current);
  }, [index, startAuto]);

  /* ================= LOOP RESET ================= */
  React.useEffect(() => {
    if (index === total) {
      setTimeout(() => {
        setIsTransitioning(false);
        setIndex(0);

        requestAnimationFrame(() => {
          setIsTransitioning(true);
        });
      }, 800);
    }
  }, [index, total]);

  /* ================= PAUSE + IDLE RESUME ================= */
  const resetIdleTimer = () => {
    if (autoRef.current) clearTimeout(autoRef.current);
    if (idleRef.current) clearTimeout(idleRef.current);

    idleRef.current = setTimeout(() => {
      startAuto();
    }, 1000); // resume after 1s idle
  };

  /* ================= BUTTONS ================= */
  const next = () => {
    setIndex((prev) => prev + 1);
    resetIdleTimer();
  };

  const prev = () => {
    setIndex((prev) => (prev === 0 ? total - 1 : prev - 1));
    resetIdleTimer();
  };

  return (
    <div
      style={{
        width: sliderWidth,
        marginTop: imageMarginTop_initial_image,
        borderRadius: "28px",
        background: "rgba(255,255,255,0.75)",
        backdropFilter: "blur(18px)",
        WebkitBackdropFilter: "blur(18px)",
        border: "1px solid rgba(255,255,255,0.35)",
        boxShadow: "0 20px 60px rgba(0,0,0,0.12)",
        padding: isMobile ? "12px" : "20px",
        overflow: "hidden",
        position: "relative",
        pointerEvents: "auto",
        opacity,
      }}
    >
      {/* LEFT BUTTON */}
      <button
        onClick={prev}
        style={{
          position: "absolute",
          left: "0px",
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 10,

          width: isMobile ? "38px" : "38px",
          height: isMobile ? "38px" : "38px",

          border: "none",
          borderRadius: "50%",

          background: "rgba(255, 255, 255, 0.52)",
          backdropFilter: "blur(12px)",
          WebkitBackdropFilter: "blur(12px)",

          color: "#000",
          fontSize: isMobile ? "18px" : "20px",
          fontWeight: "600",

          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",

          boxShadow: "0 4px 18px rgba(0,0,0,0.12)",
        }}
      >
        ‹
      </button>

      {/* RIGHT BUTTON */}
      <button
        onClick={next}
        style={{
          position: "absolute",
          right: "0px",
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 10,

          width: isMobile ? "38px" : "38px",
          height: isMobile ? "38px" : "38px",

          border: "none",
          borderRadius: "50%",

          background: "rgba(255, 255, 255, 0.52)",
          backdropFilter: "blur(12px)",
          WebkitBackdropFilter: "blur(12px)",

          color: "#000",
          fontSize: isMobile ? "18px" : "20px",
          fontWeight: "600",

          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",

          boxShadow: "0 4px 18px rgba(0,0,0,0.12)",
        }}
      >
        ›
      </button>

      {/* SLIDER */}
      <div
        style={{
          width: "100%",
          overflow: "hidden",
          borderRadius: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            width: `${slides.length * 100}%`,
            transform: `translateX(-${index * (100 / slides.length)}%)`,
            transition: isTransitioning
              ? "transform 0.8s ease-in-out"
              : "none",
          }}
        >
          {slides.map((src, i) => (
            <div
              key={i}
              style={{
                width: sliderWidth,
                height: sliderHeight,

                display: "flex",
                alignItems: "center",
                justifyContent: "center",

                background: "#fff",

                borderRadius: "20px",

                overflow: "hidden",

                flexShrink: 0,
              }}
            >
              <img
                src={src}
                alt="School"
                style={{
                  width: "100%",

                  height: "100%",

                  objectFit: "cover",

                  objectPosition: "center",

                  borderRadius: "20px",

                  background: "#fff",
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function Home() {
  const parallax = useRef(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const isMobile = useIsMobile();

  /* ================= HELPERS ================= */

  // ✅ Responsive offset
  const offset = (desktop, mobile) => (isMobile ? mobile : desktop);

  const opacityValue_initial_image =
    window.innerWidth <= 375
      ? 0
      : window.innerWidth <= 390
        ? 0
        : window.innerWidth <= 414
          ? 0
          : window.innerWidth <= 430
            ? 0
            : window.innerWidth <= 480
              ? 0
              : window.innerWidth <= 768
                ? 0
                : 0;

  const imageMarginTop_initial_image =
    window.innerWidth <= 360
      ? "30px"
      : window.innerWidth <= 375
        ? "10px"
        : window.innerWidth <= 390
          ? "40px"
          : window.innerWidth <= 414
            ? "40px"
            : window.innerWidth <= 430
              ? "45px"
              : window.innerWidth <= 480
                ? "340px"
                : window.innerWidth <= 768
                  ? "360px"
                  : "0px";

  const opacityValue_salient_text =
    window.innerWidth <= 375
      ? 0.2
      : window.innerWidth <= 390
        ? 0.3
        : window.innerWidth <= 414
          ? 0.2
          : window.innerWidth <= 430
            ? 0.2
            : window.innerWidth <= 480
              ? 0
              : window.innerWidth <= 768
                ? 0
                : 0.3;

  const imageMarginTop_salient_text =
    window.innerWidth <= 360
      ? "250px"
      : window.innerWidth <= 375
        ? "250px"
        : window.innerWidth <= 390
          ? "250px"
          : window.innerWidth <= 414
            ? "220px"
            : window.innerWidth <= 430
              ? "250px"
              : window.innerWidth <= 480
                ? "340px"
                : window.innerWidth <= 768
                  ? "360px"
                  : "730px";

  // const OffsetValue_Quote =
  //   window.innerWidth <= 375
  //     ? 0.45
  //     : window.innerWidth <= 390
  //       ? 0.47
  //       : window.innerWidth <= 414
  //         ? 0.47
  //         : window.innerWidth <= 430
  //           ? 0.47
  //           : window.innerWidth <= 480
  //             ? 0.5
  //             : window.innerWidth <= 768
  //               ? 0.5
  //               : 1;

  const imageMarginTop_salient_Quote =
    window.innerWidth <= 360
      ? "500px"
      : window.innerWidth <= 375
        ? "500px"
        : window.innerWidth <= 390
          ? "580px"
          : window.innerWidth <= 414
            ? "600px"
            : window.innerWidth <= 430
              ? "650px"
              : window.innerWidth <= 480
                ? "340px"
                : window.innerWidth <= 768
                  ? "360px"
                  : "780px";

  const opacityValue_Quote_text =
    window.innerWidth <= 375
      ? 0.5
      : window.innerWidth <= 390
        ? 0.5
        : window.innerWidth <= 414
          ? 0.5
          : window.innerWidth <= 430
            ? 0.5
            : window.innerWidth <= 480
              ? 0
              : window.innerWidth <= 768
                ? 0
                : 0.7;

  const opacityValue_ImageBlocks =
    window.innerWidth <= 375
      ? 0.9
      : window.innerWidth <= 390
        ? 0.9
        : window.innerWidth <= 414
          ? 0.8
          : window.innerWidth <= 430
            ? 0.9
            : window.innerWidth <= 480
              ? 0.6
              : window.innerWidth <= 768
                ? 0.7
                : 1.1;

  const imageMarginTop_ImageBlocks =
    window.innerWidth <= 360
      ? "0px"
      : window.innerWidth <= 375
        ? "0px"
        : window.innerWidth <= 390
          ? "-80px"
          : window.innerWidth <= 414
            ? "-100px"
            : window.innerWidth <= 430
              ? "-50px"
              : window.innerWidth <= 480
                ? "0px"
                : window.innerWidth <= 768
                  ? "0px"
                  : "0px";



  // ✅ Responsive speed
  const speedValue = (desktop, mobile) =>
    isMobile ? mobile : desktop;

  // ✅ Mobile-adjusted page height for better opacity sync
  const getPageHeightFactor = () => (isMobile ? 0.85 : 1);

  /* ================= SCROLL TRACKING ================= */
  useEffect(() => {
    const container = parallax.current?.container?.current;

    if (!container) return;

    const handleScroll = () => {
      const scrollTop = container.scrollTop;

      // ✅ Update opacity scroll tracking
      setScrollPosition(scrollTop);

      // ✅ Restrict extra scrolling for different screen widths
      let maxScroll;

      if (window.innerWidth <= 360) {
        // Small mobile
        maxScroll = window.innerHeight * (1.8 - 1);
      }
      else if (window.innerWidth <= 375) {
        // Small mobile
        maxScroll = window.innerHeight * (1.85 - 1);
      }
      else if (window.innerWidth <= 390) {
        // Small mobile
        maxScroll = window.innerHeight * (1.73 - 1);
      }
      else if (window.innerWidth <= 414) {
        // Small mobile
        maxScroll = window.innerHeight * (1.71 - 1);
      }
      else if (window.innerWidth <= 430) {
        // Small mobile
        maxScroll = window.innerHeight * (1.76 - 1);
      }
      else if (window.innerWidth <= 768) {
        // Tablet/mobile
        maxScroll = window.innerHeight * (2.55 - 1);
      }
      else if (window.innerWidth <= 1024) {
        // Small laptop
        maxScroll = window.innerHeight * (6.2 - 1);
      } else {
        // Desktop
        maxScroll = window.innerHeight * (2.1 - 1);
      }

      if (scrollTop > maxScroll) {
        container.scrollTop = maxScroll;
      }
    };

    container.addEventListener("scroll", handleScroll);

    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, [isMobile]);

  /* ================= OPACITY ================= */
  const getOpacity = (pageIndex) => {
    const pageHeight = window.innerHeight * getPageHeightFactor();
    const currentPage = scrollPosition / pageHeight;

    const diff = Math.abs(pageIndex - currentPage);
    return Math.max(0, 1 - diff / 0.7);
  };

  // /* ================= BASE STYLE ================= */
  // const baseImageStyle = {
  //   height: "auto",
  //   marginTop: "150px",
  //   transform: "translateY(0px)",
  // };

  // const getImageStyle = (mobile, extra = {}) => ({
  //   ...baseImageStyle,
  //   width: mobile ? "45vw" : "60vw",
  //   maxWidth: "600px",
  //   marginTop: mobile ? "150px" : baseImageStyle.marginTop,
  //   transform: mobile ? "none" : baseImageStyle.transform,
  //   ...extra,
  // });

  return (
    <div style={{ width: "100%", height: "100vh", background: "#fff" }}>
      <Parallax ref={parallax} pages={isMobile ? 2.35 : 5.8}>

        {/* ================= PAGE 0 ================= */}
        {/*
        <ParallaxLayer
          offset={0}
          speed={speedValue(0.3, 0.15)}
          style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center",
            pointerEvents: "none",
            opacity: getOpacity(opacityValue_initial_image),
          }}
        >
          <img
            src="https://res.cloudinary.com/dsfhaqrhn/image/upload/v1778067569/1000307126_u93wso.jpg"
            alt="Students"
            style={getImageStyle(isMobile, {
              width: isMobile ? "90vw" : "70vw",
              maxWidth: "900px",
              marginTop: isMobile ? "20px" : "0px",
            })}
          />
        </ParallaxLayer> 

        */}



        {/* <ParallaxLayer
          offset={0}
          speed={speedValue(0.5, 0.2)}
          style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center",
            pointerEvents: "none",
            opacity: getOpacity(opacityValue_initial_image),
          }}
        >
          <img
            src="https://res.cloudinary.com/dsfhaqrhn/image/upload/v1779106507/school-building-in-flat-style-modern-school-college-building-illustration-vector-removebg-preview_gkqzrt.png"
            alt="School"
            style={getImageStyle(isMobile, {
              width: isMobile ? "50vw" : "30vw",
              marginTop: imageMarginTop_initial_image
            })}
          />
        </ParallaxLayer> */}

        <ParallaxLayer
          offset={0}
          speed={speedValue(0.5, 0.2)}
          style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center",
            pointerEvents: "none",
            opacity: getOpacity(opacityValue_initial_image),
            overflow: "hidden",
          }}
        >
          <SchoolImageSlider
            isMobile={isMobile}
            imageMarginTop_initial_image={imageMarginTop_initial_image}
            opacity={getOpacity(opacityValue_initial_image)}
          />
        </ParallaxLayer>

        <ParallaxLayer
          offset={offset(0, 0)}
          speed={speedValue(0.2, 0.2)}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none",
            opacity: getOpacity(opacityValue_salient_text),
            zIndex: 10,
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",

              marginTop: imageMarginTop_salient_text,
            }}
          >

            <div
              style={{
                fontSize: isMobile ? "34px" : "82px",

                fontWeight: "700",

                letterSpacing: "-3px",

                lineHeight: "1",

                textAlign: "center",

                background:
                  "linear-gradient(180deg, #111111 0%, #444444 45%, #888888 100%)",

                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",

                textShadow:
                  "0 8px 30px rgba(0,0,0,0.08)",

                fontFamily:
                  "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif",

                transform: isMobile
                  ? "translateY(-20px)"
                  : "translateY(-40px)",

                userSelect: "none",
              }}
            >
              Our Salient Features
            </div>

          </div>
        </ParallaxLayer>

        <ParallaxLayer
          offset={offset(0, 0)}   // 👈 move it down from 1.2 → 1.35 (desktop) and adjust mobile
          speed={speedValue(0.15, 0.15)}
          style={{
            display: "flex",
            alignItems: "flex-start",   // 👈 was center (causes overlap)
            justifyContent: "center",
            pointerEvents: "none",
            opacity: getOpacity(opacityValue_Quote_text),
            zIndex: 9,
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              padding: isMobile ? "0 20px" : "0 60px",
              marginTop: imageMarginTop_salient_Quote,
            }}
          >
            <div
              style={{
                maxWidth: isMobile ? "320px" : "900px",
                textAlign: "center",

                fontSize: isMobile ? "16px" : "26px",
                fontWeight: "500",
                lineHeight: "1.6",
                letterSpacing: "0.2px",

                color: "#333",

                fontFamily:
                  "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif",

                background:
                  "linear-gradient(180deg, #1a1a1a 0%, #555555 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",

                transform: isMobile
                  ? "translateY(10px)"
                  : "translateY(20px)",

                userSelect: "none",
              }}
            >
              “Entrust us with your child as a seed, and we’ll nurture them into a strong tree of knowledge and character.”
            </div>
          </div>
        </ParallaxLayer>

        {/* ================= PAGE 1 ================= */}
        {/* ================= ROOTS SHOWCASE ================= */}

        <ParallaxLayer
          offset={offset(1.1, 0.8)}
          speed={speedValue(0.15, 0.1)}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            pointerEvents: "auto",
            zIndex: 20,
            opacity: getOpacity(opacityValue_ImageBlocks),
            marginTop: imageMarginTop_ImageBlocks,
          }}
        >
          <RootsShowcase />
        </ParallaxLayer>

      </Parallax>
    </div>
  );
}